import {Text, TextVariantUnionType} from "@pg-design/text-module";

import {PaginationSize} from "../types/PaginationSize";

import * as styles from "./PageSeparator.module.css";

interface IProps {
    size: PaginationSize;
    textVariant: TextVariantUnionType;
}

export const PageSeparator = (props: IProps) => {
    return (
        <Text as="span" className={styles.pageSeparator} data-testid="pagination-separator" variant={props.textVariant}>
            ...
        </Text>
    );
};
import {Text, TextVariantUnionType} from "@pg-design/text-module";

import {PaginationSize} from "../types/PaginationSize";

import * as styles from "./PageSeparator.module.css";

interface IProps {
    size: PaginationSize;
    textVariant: TextVariantUnionType;
}

export const PageSeparator = (props: IProps) => {
    return (
        <Text as="span" className={styles.pageSeparator} data-testid="pagination-separator" variant={props.textVariant}>
            ...
        </Text>
    );
};
